import {Button, Avatar, Space} from 'antd';
import editIcon from '../../../assets/svg/editIcon.svg';
import {addDollar, formatedDate} from '../../../utilities/helper';
import get from "lodash/get";
import isNull from "lodash/isNull"

export const columns = ({ onClickEdit, currencyCode, list }) => [
  {
    title: 'Actions',
    dataIndex: '',
    key: 2,
    
    width: 80,
    render: (text, record) => (
        <Button
            size={"small"}
            type="text"
            onClick={() => {
              onClickEdit(record);
            }}
        >
          <img src={editIcon} alt="" />
        </Button>
    )
  },
  {
    title: 'Record No.',
    dataIndex: 'batch_record_no',
    key: 'batch_record_no',
    sorter:true,
    sortDirections: ['ascend', 'descend', 'ascend'],
    sortOrder : get(list, 'sortBy') === "batch_record_no" ?(get(list, 'sortDir')==="DESC" ? "descend":"ascend") : false,
    render:(value)=> value || '-',
    width: 110
  },
  {
    title: 'Item No.',
    dataIndex: 'item_num',
    key: 'item_num',
    ellipsis: true,
    align:'right',
    width: 180
  },
  {
    title: 'Vendor No.',
    dataIndex: 'vendor_number',
    key: 'vendor_number',
    sorter:true,
    sortOrder : get(list, 'sortBy') === "vendor_number" ?(get(list, 'sortDir')==="DESC" ? "descend":"ascend") : false,
    render:(value)=> value || '-',
    width: 130,
    ellipsis: true
  },
  {
    title: 'Vendor Name',
    dataIndex: 'vendor_name',
    key: 'vendor_name',
    sorter:true,
    sortOrder : get(list, 'sortBy') === "vendor_name" ?(get(list, 'sortDir')==="DESC" ? "descend":"ascend") : false,
    width: 180,
    ellipsis: true,
    render:(value, record)=> (
      <Space>
        {!isNull(get(record, 'item_image_url')) ? <Avatar size="large" src={get(record, 'item_image_url')} /> : 
        <Avatar style={{ backgroundColor: '#FAA500'}} size="large" > {value.charAt(0)}</Avatar> }
        {value || '-'}
      </Space>
    )
  },
  {
    title: 'Vendor Part No.',
    dataIndex: 'vendor_part_num',
    key: 'vendor_number',
    ellipsis: true,
    width: 180
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: 280
  },
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price',
    align:'right',
    render: (text) => addDollar(text, currencyCode),
    width: 90
  },
  {
    title: 'Category',
    dataIndex: 'category_name',
    key: 'category_name',
    render: (text) => (text ? text : '-'),
    width: 200
  },
  {
    title: 'Sub Category',
    dataIndex: 'subcategory_name',
    key: 'subcategory_name',
    render: (text) => (text ? text : '-'),
    width: 200
  },
  {
    title: 'Publish Date',
    dataIndex: 'create_date',
    key: 'create_date',
    render: (date) => formatedDate(date),
    width: 120
  },
  {
    title: 'Effective Date',
    dataIndex: 'effective_date',
    key: 'effective_date',
    render: (date) => formatedDate(date),
    width: 120
  },

];
